import badges_app_store_black from './badges-app-store-black.svg';
import badges_app_store_white from './badges-app-store-white.svg';
import badges_google_play from './badges-google-play.svg';

export const V2_BADGES_ICONS: { [char: string]: string } = {
  badges_app_store_black,
  badges_app_store_white,
  badges_google_play,
};

export const V2_BADGES_ICON_NAMES: string[] = Object.keys(V2_BADGES_ICONS);
